import { PropsWithChildren } from "react";

import { Box, CircularProgress } from "@mui/material";

interface Props extends PropsWithChildren {
  open: boolean;
  size: number;
  /**
   * Grows the wrapper along the parent's flex axis. Off by default, so wrapping a control in a
   * filter row does not swallow the row's free space and push the controls behind it to its end.
   */
  fill?: boolean;
}

export function ScopedBackdrop({ open, size, fill = false, children }: Props) {
  return (
    <Box position="relative" display="inline-block" flex={fill ? 1 : undefined}>
      {children}

      {open && (
        <Box
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
          bgcolor="rgba(255, 255, 255, 0.9)"
          zIndex={1}
          left={0}
          top={0}
          right={0}
          bottom={0}
        >
          <CircularProgress size={size} />
        </Box>
      )}
    </Box>
  );
}
